var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 48C0 1.92 1.92 0 48 0s48 1.92 48 48-1.92 48-48 48S0 94.08 0 48z",
    fill: "url(#logo-dark_svg__paint0_linear_5567_160564)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.143 48c0-17.044 13.817-30.857 30.857-30.857 4.21 0 8.309.846 12.105 2.466a4.986 4.986 0 012.626 6.539 4.975 4.975 0 01-6.53 2.63A20.828 20.828 0 0048 27.11c-11.547 0-20.903 9.355-20.903 20.89S36.453 68.89 48 68.89c11.546 0 20.903-9.355 20.903-20.89a4.98 4.98 0 014.977-4.984A4.98 4.98 0 0178.857 48c0 17.044-13.817 30.857-30.857 30.857S17.143 65.044 17.143 48zm47.285-14.13c0-1.456.59-2.773 1.544-3.727a5.255 5.255 0 013.189-1.516l.538-.027c1.456 0 2.774.59 3.727 1.543a5.252 5.252 0 011.544 3.726c0 1.455-.59 2.773-1.544 3.726A5.255 5.255 0 0169.7 39.14a5.255 5.255 0 01-3.727-1.544 5.253 5.253 0 01-1.543-3.726z",
    fill: "url(#logo-dark_svg__paint1_linear_5567_160564)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-dark_svg__paint0_linear_5567_160564",
    x1: 24,
    y1: 96,
    x2: 72,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-dark_svg__paint1_linear_5567_160564",
    x1: 48,
    y1: 17.143,
    x2: 48,
    y2: 78.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })))));
}

export default SvgLogoDark;